import { Box, Flex } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { Cartridge, HashupCartridge } from '../../../lib/HashupCartridge/hashupCartridge';

interface Props {
	color: string;
	image: string;
	glareColor: string;
}

export const CartridgeModel: FC<Props> = ({ color, image, glareColor = '' }) => {
	const cartridgeType = useMemo(() => {
		if (color == 'gold') return Cartridge.GOLD;
		else if (color == 'gray') return Cartridge.SILVER;
		else return Cartridge.CUSTOM;
	}, [color]);

	return (
		<Flex
			justify="center"
			position="relative"
			zIndex="1"
		>
			<Box
				bg={glareColor}
				position="absolute"
				left="0"
				right="0"
				margin="auto"
				top="0"
				bottom="0"
				zIndex="2"
				width="100px"
				pointerEvents="none"
				height="100px"
				filter="blur(100px)"
			/>
			<Box
				zIndex="3"
				position="relative"
				h="300px"
				w="400px"
			>
				<Box
					position="absolute"
					top="0"
					left="0"
					right="0"
					bottom="0"
					margin="auto"
					height="400px"
					width="100%"
				>
					<HashupCartridge
						cartridge={cartridgeType}
						cartridgeCoverUri={image}
					/>
				</Box>
			</Box>
		</Flex>
	);
};
